import { useState, useEffect } from 'react';
import axios from 'axios';
import { Sparkle, Pencil, Check } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// One compact, editable "Current Direction" indicator for the top context bar.
export default function CurrentDirectionChip() {
  const { getAuthHeader } = useAuth();
  const [dir, setDir] = useState(null);
  const [presets, setPresets] = useState([]);
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState('');

  useEffect(() => {
    axios.get(`${API}/explore/direction`, getAuthHeader())
      .then((r) => { setDir(r.data.current_direction || 'Still Exploring'); setPresets(r.data.presets || []); setVal(r.data.current_direction || ''); })
      .catch(() => {});
  }, [getAuthHeader]);

  if (dir === null) return null;

  const save = async (v) => {
    const value = (v ?? val).trim();
    if (!value) return;
    setDir(value); setOpen(false);
    try { await axios.post(`${API}/explore/direction`, { current_direction: value }, getAuthHeader()); } catch { /* non-blocking */ }
  };

  return (
    <div className="relative">
      <button onClick={() => setOpen((o) => !o)} data-testid="current-direction-chip"
        className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-purple-500/15 border border-purple-400/30 text-purple-100 hover:border-purple-300 transition-colors">
        <Sparkle className="w-3 h-3" /> {dir} <Pencil className="w-2.5 h-2.5 opacity-70" />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 z-50 w-64 rounded-xl border border-purple-400/30 p-3 backdrop-blur-xl"
          style={{ background: 'rgba(6,23,54,0.97)' }} data-testid="current-direction-editor">
          <p className="text-[10px] uppercase tracking-wider text-slate-300 font-bold mb-2">Current direction</p>
          <div className="flex flex-wrap gap-1.5 mb-2">
            {presets.map((p) => (
              <button key={p} onClick={() => save(p)}
                data-testid={`direction-preset-${p.replace(/[^a-z]+/gi, '-').toLowerCase()}`}
                className="px-2 py-1 rounded-full text-[11px] border border-white/12 text-slate-300 hover:border-cyan-400/50 hover:text-white transition-colors">{p}</button>
            ))}
          </div>
          <div className="flex gap-1.5">
            <input value={val} onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && save()}
              placeholder="Type your own..." data-testid="direction-input"
              className="flex-1 rounded-lg bg-[#030C1D]/70 border border-white/12 px-2.5 py-1.5 text-xs text-white outline-none focus:border-cyan-400/50" />
            <button onClick={() => save()} data-testid="direction-save" className="p-1.5 rounded-lg bg-cyan-500/20 border border-cyan-400/40 text-cyan-200"><Check className="w-3.5 h-3.5" /></button>
          </div>
        </div>
      )}
    </div>
  );
}
